module.exports = __webpack_public_path__ + "img/18588671000423.3e32c15a.png";